import { render, staticRenderFns } from "./purchased.vue?vue&type=template&id=cb92f9f4&scoped=true&"
import script from "./purchased.vue?vue&type=script&lang=js&"
export * from "./purchased.vue?vue&type=script&lang=js&"
import style0 from "./purchased.vue?vue&type=style&index=0&id=cb92f9f4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb92f9f4",
  null
  
)

export default component.exports